
import React from 'react';
import { Briefcase, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyStateLayout } from './EmptyStateLayout';

interface JobsEmptyStateProps {
  onCreateJob?: () => void;
}

export const JobsEmptyState: React.FC<JobsEmptyStateProps> = ({ onCreateJob }) => {
  return (
    <EmptyStateLayout
      icon={Briefcase}
      title="No Job Postings Yet"
      description="Create your first job posting to start attracting qualified candidates."
      actionLabel="Create Job Posting"
      onAction={onCreateJob}
    >
      <div className="mt-6 text-sm text-muted-foreground">
        <p className="mb-2">Our AI-powered job creation helps you:</p>
        <ul className="text-left max-w-md mx-auto space-y-1">
          <li>• Generate compelling job descriptions</li>
          <li>• Set appropriate skill requirements</li>
          <li>• Optimize for candidate attraction</li>
        </ul>
      </div>
    </EmptyStateLayout>
  );
};
